import { avatarBase, statusDot } from './avatar.css';

export interface AvatarProps {
    /** Full name; the avatar shows its initials (first + last). */
    name: string;
    /** Diameter in px (default 40). */
    size?: number;
    /** Presence indicator (green dot, Untitled UI style). */
    online?: boolean;
    testID?: string;
}

function initialsOf(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    const first = parts[0][0] ?? '';
    const last = parts.length > 1 ? (parts[parts.length - 1][0] ?? '') : '';
    return (first + last).toUpperCase();
}

/** Initials avatar with optional online dot. */
export function Avatar({ name, size = 40, online = false, testID }: AvatarProps) {
    return (
        <span
            className={avatarBase}
            style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
            aria-hidden
            data-testid={testID}
        >
            {initialsOf(name)}
            {online ? <span className={statusDot} /> : null}
        </span>
    );
}
